import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from "reactstrap";
import { DropdownFilter } from "../generics/Filter";
import PropTypes from "prop-types";

import { downloadOfferItemsTemplate } from "../../store/priceLists/api";

const ModalUploadOfferItems = ({ onSubmit, vendors, closeModal, isModalOpen }) => {
  const [file, setFile] = useState(null);
  const [vendorId, setVendorId] = useState(null);

  const handleChangeFile = (event) => {
    setFile(event.target.files[0]);
  };

  const handleChangeVendor = (event) => {
    setVendorId(event.target.value);
  };

  const handleTemplateDownload = () => {
    downloadOfferItemsTemplate().then((r) => {
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Default offer items template.xlsx`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    });
  };

  return (
    <Modal isOpen={isModalOpen} toggle={closeModal} className={"modal-warning modal-logut"}>
      <ModalHeader toggle={closeModal} className="with-button">
        <span>Upload offer items list</span>
        <span className="btn btn-secondary m-0 mr-1" onClick={handleTemplateDownload}>
          Download template
        </span>
      </ModalHeader>
      <ModalBody>
        <span>Please upload the template file with the offer items</span>
        <FormGroup className="mt-1">
          <Label className="mb-0" for="exampleFile">
            Vendor
          </Label>
          <DropdownFilter colClass="col-auto" dropdownVal={vendorId} onDropdownChange={handleChangeVendor} dropdownOptions={vendors} />
        </FormGroup>
        <FormGroup className="mb-0">
          <Label className="mr-1 mb-0 " for="exampleFile">
            Template File
          </Label>
          <Input type="file" name="to_update" id="to_update" accept=".csv" onChange={handleChangeFile} />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" disabled={!vendorId} onClick={() => onSubmit({ file, vendorId: vendors[vendorId].id })}>
          Upload
        </Button>
        <Button color="secondary" onClick={closeModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalUploadOfferItems.propTypes = {
  onSubmit: PropTypes.func,
  vendors: PropTypes.array,
  closeModal: PropTypes.func,
  isModalOpen: PropTypes.func,
};

export default ModalUploadOfferItems;
